import React from "react";
import { Tag } from "interfaces/tag";
import { Machine } from "interfaces/machine";
import { ScadaDatetimeTagDataSource, BaseSeries } from "interfaces/chart";
import { Autocomplete } from "components/Autocomplete";
import { Popper } from "@mui/material";
import { Component } from "interfaces/component";

const CustomPopper = (props: any): JSX.Element => {
  return (
    <Popper
      {...props}
      style={{ minWidth: 227, maxWidth: 600 }}
      placement="bottom-end"
    />
  );
};

export interface SeriesSourceSelectorProps {
  loading: boolean;
  error: boolean;
  /** Component related props */
  components: Component[] | null;
  /** Parameter(Tag) related props */
  parameters: Tag[] | null;
  selectedParameter: Tag | null;
  onChangeParameter: (newParameter: Tag | null) => void;
  /** Machine related props */
  machines: Machine[] | null;
  selectedMachine: Machine | null;
  onChangeMachine: (newMachine: Machine | null) => void;
  /** Series related props */
  selectedSeries: BaseSeries<ScadaDatetimeTagDataSource> | null;
}

export const SeriesSourceSelector = ({
  loading,
  error,
  components,
  parameters,
  machines,
  selectedParameter,
  selectedMachine,
  onChangeParameter,
  onChangeMachine
}: SeriesSourceSelectorProps): JSX.Element => {
  return (
    <>
      <Autocomplete
        label="Machine"
        placeholder="select"
        options={machines}
        loading={loading}
        error={error}
        disabled={loading}
        size="small"
        groupBy={(option: Machine) => option.site_name}
        getOptionLabel={(option: Machine) => option.name}
        isOptionEqualToValue={(option: Machine, value: Machine) =>
          option.id === value.id
        }
        onChange={(_event: React.ChangeEvent<{}>, newMachine: Machine | null) =>
          onChangeMachine(newMachine)
        }
        value={selectedMachine}
        PopperComponent={CustomPopper}
      />
      <Autocomplete
        label="Parameter"
        placeholder="select"
        fullWidth
        options={parameters}
        loading={loading}
        error={error}
        disabled={loading || selectedMachine === null}
        size="small"
        groupBy={(option: Tag) => {
          const component = components?.find(x => x.id === option.component);
          if (!component) {
            return "No Component";
          } else {
            return component.name;
          }
        }}
        getOptionLabel={(option: Tag) => option.name}
        isOptionEqualToValue={(option: Tag, value: Tag) =>
          option.id === value.id
        }
        onChange={(_event: React.ChangeEvent<{}>, newParameter: Tag | null) =>
          onChangeParameter(newParameter)
        }
        value={selectedParameter}
        PopperComponent={CustomPopper}
      />
    </>
  );
};
